<template>
  <el-input-number v-model="currentValue" for-test="currentValue" @blur="blurInput($event)" @input.native="inputValue($event)" :step="1" :min="0" :disabled="disabled"></el-input-number>
</template>
<style scoped lang="scss">
  /deep/ span{
    display:none;
  }
</style>
<!--☯js-->
<script>
  import * as eventJs from '../../../../../../src/base-components/number-input/event.js'
  const {event, life, watch} = eventJs.default ? eventJs.default : eventJs
  import * as modelJS from '../../../../../../src/base-components/number-input/model.js'
  const model = modelJS.default ? modelJS.default : modelJS
  const methodsSource = {}
  import vmConfig from '../../../../core/vmConfigHandler.js'
  // 异步加载某些情况下会出问题，原因未知，所以暂时不采用异步加载
  // r => require.ensure([], () => r(require('%path')), 'c-base-number-input')
  export default {
    name: 'base-number-input', // o not use built-in or reserved HTML elements as component id:img, 意思是不能和html标签同名，那么加个下划线好了
    components: {
      /*import components file template:'base-number-input': require('%path').default,
       */
      /*start:import components file*/
/*end:import components file*/
    },
    ...vmConfig(model, life, event, watch, methodsSource)
  }
</script>